const subTransfer = (data, operation, prevData) => {
    const { condition, subEntity, transferMap } = operation

    if (data[condition[0]] !== condition[1]) {
        return data
    }

    // Create new sub entity item
    let subEntityItem = {}

    // Iterate over the keys of transferMap
    for (const key in transferMap) {
        if (transferMap.hasOwnProperty(key)) { // Ensure it's an own property
            subEntityItem[transferMap[key]] = data[key];
        }
    }

    // Return new object with updated subEntity array instead of mutating
    return {
        ...data,
        [subEntity]: [subEntityItem]
    }
}

export default subTransfer
